<app-master-detail-layout
    [isMobile]="isMobile"
    [showDetail]="showDetailMobile"
    (backToSidebar)="goBack()"
>
    <span sidebarTitle #sidebarTitle>{{'FIDELITY.SETUP.CAMPAIGNS.TITLE' | translate}}</span>

    <div sidebarActions #sidebarActions>
        <button mat-icon-button
            (click)="addCampaign()"
        >
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <div sidebar>
        @for(campaign of campaignsList; track campaign.id; let i = $index) {
            <app-sidebar-item [isActive]="campaign.isValid"
                [isSelected]="isSelected(campaign)"
                (click)="selectCampaign($event, i)"
            >
                <mat-icon start>{{campaign.isValid? 'event_available': 'event_busy'}}</mat-icon>
                
                <span title #title>{{ campaign.name }}</span>

                @if (campaign.from_date || campaign.to_date) {
                    <div subtitle #subtitle class="tw-truncate tw-w-full">
                        @if(campaign.from_date) {
                            <span>
                                {{ 'FIDELITY.SETUP.CAMPAIGNS.FROM_DATE' | translate:{ date: (campaign.from_date | date:'dd/MM/yyyy') } }}
                            </span>
                        } 
                        @if(campaign.to_date) {
                            <span>
                                {{ 'FIDELITY.SETUP.CAMPAIGNS.TO_DATE' | translate:{ date: (campaign.to_date | date:'dd/MM/yyyy') } }}
                            </span>
                        }
                    </div>
                }

                <mat-slide-toggle end 
                    [checked]="campaign.active" 
                    [disabled]="campaign.id === selectedCampaign?.id"
                    (click)="$event.stopPropagation()" 
                    (change)="onToggleCampaign($event, campaign)"></mat-slide-toggle>
            </app-sidebar-item>
        }

    </div>

    <div headerTitle class="tw-w-full tw-min-w-0">
        @if(isNotEmptyState) {
            <span class="tw-w-full" [appTruncatedText]="fidelityCampaignFormService.name?.value || ''"
            >{{fidelityCampaignFormService.name?.value || ('FIDELITY.SETUP.CAMPAIGNS.PLACEHOLDER_NAME' | translate)}}</span>
        }
    </div>

    <ng-container actions>
        @if(isNotEmptyState) {
            @if(selectedCampaign?.id) {
                <app-action-btn variant="basic" 
                    (click)="deleteCampaign()"
                >
                Elimina
                </app-action-btn>
            } 
            <app-action-btn 
                [disabled]="!campaignForm.valid"
                (click)="saveCampaign()"
            >
            Salva
            </app-action-btn>
        }
    </ng-container>

    <ng-container content>

        @if(isNotEmptyState) {
            <form autocomplete="off" [formGroup]="campaignForm" class="tw-contents">
                <app-card 
                    [fullWidth]="false"
                    [withCard]="true"
                    [cardTitle]="'FIDELITY.SETUP.CAMPAIGNS.GENERAL_SECTION' | translate"
                >
                    <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
                
                        <div class="tw-col-span-12 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-4 tw-pb-4">
                            <div class="tw-col-span-12 tw-flex tw-items-center">
                                <mat-slide-toggle formControlName="active" aria-label="{{'FIDELITY.SETUP.CAMPAIGNS.ACTIVE' | translate}}"
                                    class="tw-p-3">{{'FIDELITY.SETUP.CAMPAIGNS.ACTIVE' | translate}}</mat-slide-toggle>
                            </div>
                        </div>
                
                        <mat-form-field class="tw-col-span-12">
                            <mat-label translate>FIDELITY.SETUP.CAMPAIGNS.NAME</mat-label>
                            <input matInput formControlName="name" appTrimInput>
                            <mat-hint [align]="'end'">{{fidelityCampaignFormService.name?.value?.length || '0'}}
                                / {{fidelityCampaignFormService.validators.nameMaxLength}}</mat-hint>
                            @if(fidelityCampaignFormService.name?.hasError('maxlength')) {
                                <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{fidelityCampaignFormService.validators.nameMaxLength}})</mat-error>
                            } @else if(fidelityCampaignFormService.name?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>
                        
                        <div class="tw-col-span-12 lg:tw-col-span-6">
                            <tilby-datetime-picker formControlName="from_date" label="FIDELITY.SETUP.CAMPAIGNS.FROM" />
                        </div>
                        <div class="tw-col-span-12 lg:tw-col-span-6">
                            <tilby-datetime-picker formControlName="to_date" label="FIDELITY.SETUP.CAMPAIGNS.TO" />
                        </div>
    
                        <mat-form-field class="tw-col-span-12">
                            <mat-label translate>FIDELITY.SETUP.CAMPAIGNS.RULES_APPLICATION_ON_PRIZES</mat-label>
                            <mat-select formControlName="rules_application_on_prizes">
                                @for(rule of ruleApplicationTypes; track rule.value) {
                                    <mat-option [value]="rule.value">{{rule.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </section>
                </app-card>

                <app-card 
                    [fullWidth]="false" 
                    [withCard]="true"
                    [cardTitle]="'FIDELITY.SETUP.RULES.TITLE' | translate"
                >
                    <!-- Regole -->
                    <div class="tw-col-span-12 tw-mt-2 tw-px-2">
                        <button type="button" mat-button color="primary" 
                            aria-label="Add barcode"    
                            class="tw-p-0"
                            (click)="addRule()">
                            <div class="tw-flex tw-items-center">
                                <mat-icon class="tw-flex-none">add_circle</mat-icon>
                                <span class="tw-ml-2 tw-text-left">{{ 'FIDELITY.SETUP.CAMPAIGNS.RULE' | translate }}</span>
                            </div>
                        </button>
                    </div>

                    @if(fidelityCampaignFormService.rulesArray?.length) {
                        <div formArrayName="rules" class="tw-col-span-12 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-4">
                            @for (rule of fidelityCampaignFormService.rulesArray?.controls; track rule; let i = $index) {
                                <div [formGroupName]="i" class="tw-border-0 firts:tw-pt-0 md:tw-pt-0 tw-col-span-12">
                                    <section class="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-3">
                                        <div class="tw-flex tw-items-baseline tw-w-full">
                                            <!-- Pulsante Elimina -->
                                            <button type="button" mat-button 
                                                aria-label="Remove variation" 
                                                class="tw-min-w-fit tw-mr-2"
                                                (click)="removeRule(i)"
                                            >
                                                <div class="tw-flex">
                                                    <mat-icon>delete_forever</mat-icon>
                                                </div>
                                            </button>
                            
                                            <mat-form-field class="tw-w-full">
                                                <mat-label>Seleziona una regola</mat-label>
                                                <mat-select formControlName="id">
                                                    @for(rule of rulesList; track rule.id) {
                                                        <mat-option [value]="rule.id">{{rule.name}}</mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </section> 
                                </div>
                            }
                        </div>
                    } 
                    @else {
                        <div class="tw-p-3 tw-col-span-12 tw-opacity-50">
                            {{'FIDELITY.SETUP.CAMPAIGNS.RULES_EMPTY' | translate}}
                        </div>
                    }
                </app-card>


                <app-card 
                    [fullWidth]="true" 
                    [withCard]="true"
                    [cardTitle]="'FIDELITY.SETUP.CAMPAIGNS.ITEMS' | translate"
                >
                    <!-- Prodotti -->
                    <div class="tw-col-span-12 tw-mt-2 tw-px-2">
                        <button type="button" mat-button color="primary" 
                            aria-label="Add barcode"    
                            class="tw-p-0"
                            (click)="addItem()">
                            <div class="tw-flex tw-items-center">
                                <mat-icon class="tw-flex-none">add_circle</mat-icon>
                                <span class="tw-ml-2 tw-text-left">{{ 'FIDELITY.SETUP.CAMPAIGNS.ITEM' | translate }}</span>
                            </div>
                        </button>
                    </div>

                    @if(fidelityCampaignFormService.itemsArray?.length) {
                        <div formArrayName="items" class="tw-col-span-12">
                            @for (rule of fidelityCampaignFormService.itemsArray?.controls; track rule; let i = $index) {
                                <div [formGroupName]="i" class="tw-border-0 tw-border-b tw-border-solid tw-border-[var(--sys-divider)] 
                                    md:tw-border-0 last:tw-border-0 firts:tw-pt-0 md:tw-pt-0 tw-pt-2">
                                    <section class="tw-pt-2 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                                        <div class="tw-flex tw-items-baseline tw-col-span-12 md:tw-col-span-5">
                                            <!-- Pulsante Elimina -->
                                            <button type="button" mat-button 
                                                aria-label="Remove variation" 
                                                class="tw-min-w-fit tw-mr-2"
                                                (click)="removeItem(i)"
                                            >
                                                <div class="tw-flex">
                                                    <mat-icon>delete_forever</mat-icon>
                                                </div>
                                            </button>
                            
                                            <mat-form-field class="tw-w-full">
                                                <mat-label translate>FIDELITY.SETUP.CAMPAIGNS.NAME</mat-label>
                                                <input matInput formControlName="name" appTrimInput readonly
                                                    (click)="editItem(i)"
                                                >
                                            </mat-form-field>
                                        </div>

                                        <div class="tw-col-span-12 md:tw-col-span-5 tw-flex">
                                            <div class="tw-w-[48px] md:tw-hidden"></div> 
                                            
                                            <mat-form-field class="tw-flex-1">
                                                <mat-label translate>FIDELITY.SETUP.CAMPAIGNS.SKU</mat-label>
                                                <input matInput formControlName="sku" appTrimInput readonly
                                                    (click)="editItem(i)"
                                                >
                                            </mat-form-field>
                                        </div>

                                        <div class="tw-col-span-12 md:tw-col-span-2 tw-flex">
                                            <div class="tw-w-[48px] md:tw-hidden"></div> 
                                            
                                            <mat-form-field class="tw-flex-1">
                                                <mat-label translate>FIDELITY.SETUP.CAMPAIGNS.POINTS</mat-label>
                                                <input matInput type="number" formControlName="points"
                                                    [min]="1">
                                            </mat-form-field>
                                        </div>
                                    </section> 
                                </div>
                            }
                        </div>
                    }
                    @else {
                        <div class="tw-p-3 tw-col-span-12 tw-opacity-50">
                            {{'FIDELITY.SETUP.CAMPAIGNS.ITEMS_EMPTY' | translate}}
                        </div>
                    }
                </app-card>


                <app-card 
                    [fullWidth]="true" 
                    [withCard]="true"
                    [cardTitle]="'FIDELITY.SETUP.PRIZES.TITLE' | translate"
                >
                    @if(selectedCampaign?.id && prizesByCampaign[selectedCampaign?.id || 0]?.length) {
                        <div class="tw-col-span-12 tw-px-3">
                            @for (prize of prizesByCampaign[selectedCampaign?.id || 0]; track prize.id; let i = $index) {
                                <div class="tw-border-0 tw-border-b tw-border-solid tw-border-[var(--sys-divider)] 
                                    md:tw-border-0 last:tw-border-0 firts:tw-pt-0 md:tw-pt-0 tw-pt-2">

                                    <section class="tw-pt-2 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-6 tw-py-4">
                                        <div class="tw-col-span-12 md:tw-col-span-4 tw-flex tw-flex-col">
                                            <span [class]="priceLabelClass" translate>
                                                FIDELITY.SETUP.PRIZES.NAME
                                            </span>
                                            <span [class]="priceValueClass">
                                                {{ prize.name }}
                                            </span>
                                        </div>

                                        <div class="tw-col-span-12 md:tw-col-span-4 tw-flex tw-flex-col">
                                            <span [class]="priceLabelClass" translate>
                                                FIDELITY.SETUP.PRIZES.TYPE
                                            </span>
                                            <span [class]="priceValueClass">
                                                {{ prize._typeString }}
                                            </span>
                                        </div>

                                        <div class="tw-col-span-12 md:tw-col-span-4 tw-flex tw-flex-col">
                                            <span [class]="priceLabelClass" translate>
                                                FIDELITY.SETUP.PRIZES.POINTS
                                            </span>
                                            <span [class]="priceValueClass">
                                                {{ prize.points || 0 }}
                                            </span>
                                        </div>
                                    </section>
                                </div>
                            }
                        </div>
                    }
                    @else {
                        <div class="tw-pb-3 tw-px-3 tw-col-span-12 tw-opacity-50">
                            {{'FIDELITY.SETUP.CAMPAIGNS.PRIZES_EMPTY' | translate}}
                        </div>
                    }
                </app-card>
            </form>
        } @else {
            <ng-container *ngTemplateOutlet="emptyState"></ng-container>
        }
    </ng-container>
</app-master-detail-layout>

<ng-template #emptyState>
    <section class="lg:tw-col-span-2 tw-col-span-1 tw-h-full tw-block">
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-flex-1 tw-text-center">
            <div class="tw-bg-slate-50 tw-rounded-full tw-p-2 tw-text-slate-400">
                <mat-icon class="!tw-w-24 !tw-h-24 tw-text-[96px]">ads_click</mat-icon>
            </div>
            <h3 class="tw-font-semibold tw-text-slate-500 tw-max-w-md">
                {{ 'FIDELITY.SETUP.CAMPAIGNS.CAMPAIGN_NOT_SELECTED_MSG' | translate }}
            </h3>
        </div>
    </section>
</ng-template>